import React, { Component } from 'react';
import queryString from 'query-string';
import { Form, Field } from 'react-final-form';
import { GlobalContext } from '../global-context';
import Styles from "../Styles.js";

const minSigLength = 5

const sigRequired = (value) => {
    if (! value) {
        return "Required"
    }
    if (value.length < minSigLength) {
        return "Too short"
    }
    const spaces = value.match(/([\s])/g)
    if (spaces === null) {
        return undefined
    }
    if (value.length - spaces.length < minSigLength) {
        return "Too few characters"
    }
    return undefined
}

export default class DocSignContainer extends Component {
    static contextType = GlobalContext;

    constructor(props) {
        super(props);
        this.state = {
            readyToRender: false,
            docname: null,
            projectID: null,
            doc: null,
            proj: null
        };
    }

    async loadDocument() {
        const { setGlobalError } = this.context;
        const values = queryString.parse(this.props.location.search);
        const docname = values.document;
        const project = values.project;
        let getdoc
        let res = await fetch(`/api/project/${project}/document/read/${docname}`);
        if (res.ok) {
            getdoc = await(res.json());
            res = await fetch(`/api/project/${project}`);
            if (res.ok) {
                let proj = await(res.json());
                this.setState({
                    readyToRender: true,
                    projectID: project,
                    docname: docname,
                    doc: getdoc,
                    proj: proj
                })
            } else {
                const errdata = await res.json();
                const message = `error ${res.status} fetching project: ${errdata.message}`;
                console.log(message);
                setGlobalError(message);
            }
        } else {
            const errdata = await res.json();
            const message = `error ${res.status} fetching document: ${errdata.message}`;
            console.log(message);
            setGlobalError(message);
        }
    }

    componentDidMount() {
        this.loadDocument();
    }

    onSubmit = async (values) => {
        const { doc, docname } = this.state;
        const { updatePerson, setGlobalError } = this.context;
        const sigobj = {
            name: this.state.docname
        }
        sigobj.signatures = doc.signature_boxes.map((label, index) => {
            let sig = {
                label: label,
                signature: values["sig-" + index]
            }
            return sig
        });
        const endpoint = `/api/project/${this.state.projectID}/document/sign/${doc.instance}`;
        let res = await fetch(endpoint, {
            method: 'PUT',
            body: JSON.stringify(sigobj),
            headers:{
                'Content-Type': 'application/json'
            }
        });
        if (res && res.ok) {
            updatePerson();
        } else {
            let errdata = await res.json()
            const message = `error ${res.status} signing document ${docname}: ${errdata.message}`;
            console.log(message);
            setGlobalError(message);
        }
        // TODO: indicate error in UI?
        this.props.navigate(`project/${this.state.projectID}`);
    }

    render() {
        if (!(this.state.readyToRender)) {
            return null
        }

        const doc = this.state.doc;

        const docHTML = () => {
            let dochtml = doc.document
            return {
                __html: dochtml
            }
        }
        const boxes = doc.signature_boxes.map((sig, idx) =>
            <div key={idx}>
                <Field
                    name={"sig-" + idx}
                    component="input"
                    placeholder="signature"
                    validate={sigRequired}
                >
                    {({ input, meta }) => (
                        <div>
                            <label>{sig}: </label>
                            <input {...input} autoComplete="off" type="text" placeholder="Please type your full name" />
                                {meta.error && meta.touched && <span> {meta.error}</span>}
                        </div>
                    )}
                </Field>
            </div>
        );
        return (
            <div style={{padding: "50px"}}>
                <div dangerouslySetInnerHTML={docHTML()} />
                <Styles>
                  <Form
                      onSubmit={this.onSubmit}
                      render={({handleSubmit, submitting, pristine, invalid }) => (
                          <form onSubmit={handleSubmit}>
                              {boxes}
                              <button type="submit" disabled={pristine || invalid || submitting}>
                                  Sign
                              </button>
                          </form>
                      )}
                  />
                </Styles>
            </div>
        );
    }
}
